export const getAutomationId = (genericIdentifier: string, ...uniqueIdentifiers: (string | undefined)[]): string => {
    const separator = '_';
    const unique = uniqueIdentifiers.find((el) => el);
    return unique ? genericIdentifier + separator + unique : genericIdentifier;
};
